export const ANNOTATION_ITEM_HEIGHT = 60;
export const HEADER_HEIGHT = 60;